var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "camera-view-controls d-flex align-center"
  }, [_c('v-menu', {
    attrs: {
      "offset-y": "",
      "disabled": _vm.disabled
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function (_ref) {
        var on = _ref.on,
          attrs = _ref.attrs;
        return [_c('v-btn', _vm._g(_vm._b({
          staticClass: "camera-view-button",
          attrs: {
            "icon": "",
            "disabled": _vm.disabled,
            "title": `Camera view: ${_vm.selectedViewLabel}`
          }
        }, 'v-btn', attrs, false), on), [_c('v-icon', [_vm._v("mdi-rotate-3d-variant")])], 1)];
      }
    }])
  }, [_c('v-list', {
    staticClass: "camera-view-menu",
    attrs: {
      "dense": ""
    }
  }, _vm._l(_vm.views, function (view) {
    return _c('v-list-item', {
      key: view.value,
      on: {
        "click": function ($event) {
          return _vm.$emit('change-view', view.value);
        }
      }
    }, [_c('v-list-item-icon', {
      staticClass: "mr-2"
    }, [_c('v-icon', {
      attrs: {
        "small": ""
      }
    }, [_vm._v(_vm._s(view.icon))])], 1), _c('v-list-item-title', {
      staticClass: "camera-view-option",
      class: {
        selected: view.value === _vm.value
      }
    }, [_vm._v(" " + _vm._s(view.name) + " ")])], 1);
  }), 1)], 1), _c('v-btn', {
    staticClass: "follow-subject-button",
    attrs: {
      "icon": "",
      "disabled": _vm.disabled,
      "title": _vm.follow ? 'Follow on' : 'Follow off'
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('update:follow', !_vm.follow);
      }
    }
  }, [_c('v-icon', [_vm._v(_vm._s(_vm.follow ? 'mdi-crosshairs-gps' : 'mdi-crosshairs'))])], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }